import { createFileRoute } from '@tanstack/react-router';

import { drawerIsOpenAtom } from '@/features/demand-events/demand-event-details-loader/state/demand-event-drawer.state';
import { selectedEventAtom } from '@/features/demand-events/demand-event-details-loader/state/selected-event.state';
import { jotaiStore } from '@/providers/jotai/jotai-store';
import UserStateAtoms from '@/state/user.state';
import { resolveFacilityFromParams } from '@/utils/facility-resolver';

export const Route = createFileRoute('/$org/$agent/demand-events')({
  beforeLoad: () => {
    // Reset drawer state to prevent stale state from previous visits
    jotaiStore.set(drawerIsOpenAtom, false);
    jotaiStore.set(selectedEventAtom, null);
  },
  loader: ({ params }) => {
    // Resolve agentId from params + userState (set in root loader)
    const userState = jotaiStore.get(UserStateAtoms.user);
    const { agentId } = resolveFacilityFromParams(params, userState);

    return { agentId };
  },
});
